var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-events-listing__form"},[_c('search-form'),_c('search-results'),_c('pagination')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }